import $ from 'jquery'
import * as infiniteScroll from '../scripts/infinite-scroll'

const eventSet = {
  dataKeeper: '#event-overview-data-keeper-js',
  overviewContainer: '#event-overview-container',
  overviewInfiniteScrollingMarker: '#event-overview-infinite-scrolling-marker',
  cookieName: 'eventoverview',
  btn: '.btn',
  backToTop: '#infinite-scrolling-back-to-top',
  selector: '.event-teaser-module',
  renderIdentify: 'event-overview-render-url'
}

function init () {
  if ($(eventSet.dataKeeper).length !== 0) {
    infiniteScroll.init(eventSet)
  }

  infiniteScroll.setFilterElements($('#event-overview-page #category-dropdown'), $('#event-overview-page #year-dropdown'), $('#event-overview-page #filter-search-input'))
  $('#event-overview-page #category-dropdown').on('change', function () {
    startFilter()
  })

  $('#event-overview-page .filter-reset-js').on('click', function () {
    infiniteScroll.resetFilterObject()
    infiniteScroll.resetPage()
    infiniteScroll.emptyContent()
    setTimeout(function () {
      infiniteScroll.getArticles()
    }, 500)
  })

  $('#event-overview-page #filter-search-input').on('keypress', function (e) {
    if (e.keyCode == 13) {
      startFilter()
    }
  })

  $('#event-overview-page #filter-search-input').siblings('.search-icon').on('click', function () {
    startFilter()
  })

  function startFilter () {
    infiniteScroll.setFilter()
    infiniteScroll.resetPage()
    infiniteScroll.emptyContent()
    setTimeout(function () {
      infiniteScroll.getArticles()
    }, 500)
  }

}

export default {
  init
}
